/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/sms" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsAppGroupIdChartsSms } from "./constants";
import type { AppsAppGroupIdChartsSmsResult } from "./types";

export const getAppsAppGroupIdChartsSms = reactQueryFetcherAdapter(
  appsAppGroupIdChartsSms,
  (
    signal: AbortSignal,
    appGroupId: string,
    startDate: number,
    endDate: number
  ): Promise<AppsAppGroupIdChartsSmsResult> => {
    return fetch(
      `/apps/${appGroupId}/charts/sms`,
      "GET",
      {
        start_date: startDate,
        end_date: endDate,
      },
      { signal }
    );
  }
);
